import React from 'react'
import { useHistory } from 'react-router'
import { useAuth } from '@nic/kc-auth'

export const RealmSwitcher: React.FC = () => {
  const { keycloak } = useAuth()
  const history = useHistory()

  React.useEffect(() => {
    if (keycloak !== undefined) {
      const { realm } = keycloak
      history.push(`${realm}/dashboard`)
    }
  }, [history, keycloak])

  return <></>
}
